import { Injectable } from "@angular/core";
import { ActivatedRouterStateSnapshot, PageType, ProductSearchPage, RoutingService } from "@spartacus/core";
import { FacetList, ProductFacetService, ProductListComponentService } from "@spartacus/storefront";
import { Observable, of } from "rxjs";
import { switchMap, withLatestFrom } from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class GenProductFacetService extends ProductFacetService {
  constructor(
    override routing: RoutingService,
    override productListComponentService: ProductListComponentService
  ) {
    super(routing, productListComponentService);
  }

  override filterForPage(
    state: ActivatedRouterStateSnapshot,
    page: ProductSearchPage
  ): boolean {
    if (!page.currentQuery?.query?.value) {
      return false;
    }
    if (state.context.type === PageType.CATEGORY_PAGE) {
      return (
        page.currentQuery.query.value.indexOf(
          `allCategories:${state.context.id}`
        ) > -1
      );
    }

    if (
      state.context.type === PageType.CONTENT_PAGE &&
      state.context.id.indexOf('search') > -1
    ) {
      return true;
    }
    return false;
  }

  override facetList$: Observable<FacetList> = this.searchResult$.pipe(
    withLatestFrom(this.routeState$),
    switchMap(([result, routeState]) => of({
      facets: String(routeState?.queryParams?.tab) === '2' ? [] : result.facets.filter((facets) => {
        const isPartsTab = String(routeState?.queryParams?.tab) === '1';
        return !(isPartsTab && facets.values.some(v => v.name == 'Service Parts'));
      }),
      activeFacets: String(routeState?.queryParams?.tab) === '2' ? [] : result.breadcrumbs
        .filter((breadcrumb) => {
          const isPartsTab = String(routeState?.queryParams?.tab) === '1';
          return !(isPartsTab && breadcrumb.facetCode === 'servicePart');
        })
        .filter((breadcrumb) => breadcrumb.facetCode !== 'allCategories'
          || (result.categoryCode && breadcrumb.facetValueCode == result.categoryCode)),
    } as FacetList))
  );
}